export const TASK_MANAGEMENT_GROUP_LINKS = {
  BASE: "/app/task-management",
};
